import { call } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';

export function* onDimensionsChangedSaga() {
  yield call(RTCClient.receivingFeed.updateSimulcastConfig);
}
